import { render, staticRenderFns } from "./XFormFieldset.vue?vue&type=template&id=f48a6ca2&scoped=true&"
import script from "./XFormFieldset.vue?vue&type=script&lang=js&"
export * from "./XFormFieldset.vue?vue&type=script&lang=js&"
import style0 from "./XFormFieldset.vue?vue&type=style&index=0&id=f48a6ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48a6ca2",
  null
  
)

export default component.exports